import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {VERIFICATION_CAMERA} from "../../util/RouteConstants";
import VerificationCameraDeviceOverviewContextProvider from "./context/VerificationCameraDeviceOverviewContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class VerificationCameraDevicePage extends Component {
    render() {

        const getVerificationCameraRoutes = () => {
            return VERIFICATION_CAMERA;
        }

        return (
            <Column>
                <VerificationCameraDeviceOverviewContextProvider>
                    <TabLayout routes={getVerificationCameraRoutes()} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={getVerificationCameraRoutes()}/>
                </VerificationCameraDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default VerificationCameraDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/VerificationCameraDevicePage.js